import { render } from "./CreateNewProject.vue?vue&type=template&id=37873b0e"
import script from "./CreateNewProject.vue?vue&type=script&lang=js"
export * from "./CreateNewProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__